/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import 'react-toastify/dist/ReactToastify.css';
import theme from '../../../config/theme.json';

const whiteWithOpacity = `${theme.colors.primary.white}E6`;

export const Wrapper = styled.div`

--toastify-icon-color-error: ${whiteWithOpacity} !important;
--toastify-icon-color-success: ${whiteWithOpacity} !important;
--toastify-text-color-light: ${whiteWithOpacity} !important;
--toastify-z-index: ${theme.zIndex.notifyManager} !important;

.Toastify__toast-icon {
  display: none;
}

.Toastify__toast--error {
  background: rgb(236, 9, 47);
  top: 50px ;
  opacity: 0.9 ;
  left: -20px ;
  min-width: 100vw;
}

.Toastify__toast--success {
  background: rgb(71, 165, 42);
  top: 50px;
  left: -20px;
  min-width: 100vw;
}

.Toastify__toast--warning {
  background: #FEB500;
  top: 50px;
  left: -20px;
  min-width: 100vw;
}

.Toastify__close-button {
  margin-top:10px
}

.Toastify__close-button > svg {
  fill:white
}

.JNM-Toast {
  position:absolute !important;
  top: -12px !important;
  left: -16px !important
}

@media only screen and (max-width: 480px){
  .JNM-Toast {
    top: 0 !important;
    left: 0 !important
}
}
`;
